export default "__VITE_ASSET__adc2da07__"